import React, { useState } from "react";
import { Navigate, useLocation} from "react-router-dom";
import ReactGA from "react-ga4";
import UserAgreement from "../../api/userAgreement";
import UserContext from "../../context/UserContext";

const RouteChangeTracker = React.memo(() => {
  const location = useLocation();
  const userContext = React.useContext(UserContext);
  const [response, setResponse] = useState(<div></div>)

  React.useEffect(() => {
    setResponse(<div></div>);

    const checkAgreement = async () => {
      const agreement = await UserAgreement.CheckUserAgreement(userContext.user.id);
      if (!agreement.isPolicyApproved) {
        setResponse(<Navigate
          to="/policyconfirm"
          state={{
          userData: userContext.user, 
          originLocation: window.location.pathname
          }}
        />);
      }
    }

    if (!['/', '/authorize', '/policyconfirm'].includes(location.pathname)) {
      checkAgreement();
    }

    // Google Analytics
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: "infoceanus connect ga4" });
  }, [location]);

  return response;
});

export default RouteChangeTracker;
